import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes, FaHeart, FaRegHeart } from 'react-icons/fa';
import './model.css';

const modelsData = [
  {
    id: 1,
    name: 'Aanya Sharma',
    age: 6,
    city: 'Delhi',
    height: `3'8"`,
    hair: 'Dark Brown',
    eyes: 'Brown',
    coverImage: 'https://images.unsplash.com/photo-1517677129300-07b130802f46?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1517677129300-07b130802f46?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1596870230751-ebdfce98ec42?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1543332164-6e82f355badc?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1471286174890-9c112ffca56a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519456264917-42d0aa2e0625?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1526413232644-8a40f08ccb65?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1485546246426-74dc88dec4d9?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 2,
    name: 'Myra Kapoor',
    age: 4,
    city: 'Mumbai',
    height: `3'3"`,
    hair: 'Black',
    eyes: 'Dark Brown',
    coverImage: 'https://images.unsplash.com/photo-1596870230751-ebdfce98ec42?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1596870230751-ebdfce98ec42?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517677129300-07b130802f46?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1543332164-6e82f355badc?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1471286174890-9c112ffca56a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519456264917-42d0aa2e0625?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1526413232644-8a40f08ccb65?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1485546246426-74dc88dec4d9?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 3,
    name: 'Kiara Vats',
    age: 7,
    city: 'Delhi',
    height: `4'0"`,
    hair: 'Dark Brown',
    eyes: 'Hazel',
    coverImage: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517677129300-07b130802f46?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1596870230751-ebdfce98ec42?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1543332164-6e82f355badc?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1471286174890-9c112ffca56a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519456264917-42d0aa2e0625?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1526413232644-8a40f08ccb65?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1485546246426-74dc88dec4d9?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 4,
    name: 'Anvi Joshi',
    age: 9,
    city: 'Bangalore',
    height: `4'4"`,
    hair: 'Black',
    eyes: 'Black',
    coverImage: 'https://images.unsplash.com/photo-1543332164-6e82f355badc?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1543332164-6e82f355badc?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1517677129300-07b130802f46?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1596870230751-ebdfce98ec42?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1471286174890-9c112ffca56a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519456264917-42d0aa2e0625?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1526413232644-8a40f08ccb65?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1485546246426-74dc88dec4d9?w=900&auto=format&fit=crop&q=80',
    ],
  },
];

function FemalechildModel() {
  const [selectedModel, setSelectedModel] = useState(null);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);
  const [shortlisted, setShortlisted] = useState([]);

  // Open modal
  const openModelViewer = (model) => {
    setSelectedModel(model);
    setActivePhotoIndex(0);
  };

  // Close modal
  const closeModelViewer = () => {
    setSelectedModel(null);
  };

  // Manual Previous Slide
  const handlePrev = () => {
    if (!selectedModel) return;
    setActivePhotoIndex((prev) =>
      prev === 0 ? selectedModel.photos.length - 1 : prev - 1
    );
  };

  // Manual Next Slide
  const handleNext = () => {
    if (!selectedModel) return;
    setActivePhotoIndex((prev) =>
      prev === selectedModel.photos.length - 1 ? 0 : prev + 1
    );
  };

  // Toggle Shortlist
  const toggleShortlist = (id) => {
    setShortlisted((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <div className="female-model-page">
      <div className="page-container">
        <header className="page-header">
          <h1 className="page-title">Female Child Models</h1>
          <p className="page-desc">
            Discover aspiring and professional child artists for TV commercials, print shoots, kids fashion brands, and cinema. Click on any artist to preview their compcard portfolio.
          </p>
        </header>

        {/* Grid List */}
        <div className="models-grid">
          {modelsData.map((model) => (
            <div
              key={model.id}
              className="model-card"
              onClick={() => openModelViewer(model)}
            >
              <div className="card-image-wrapper">
                <img src={model.coverImage} alt={model.name} className="model-img" />
              </div>
              <div className="model-info">
                <span className="model-name">
                  {model.name} ( AGE {model.age} )
                </span>
                <span className="model-city">{model.city}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FULL WINDOW LIGHTBOX MODAL */}
      {selectedModel && (
        <div className="modal-backdrop" onClick={closeModelViewer}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button className="modal-close-btn" onClick={closeModelViewer}>
              <FaTimes />
            </button>

            {/* Split Top View: Image Slider (Left) & Details (Right) */}
            <div className="modal-split-body">
              {/* Left Side: Manual Image Slider */}
              <div className="slider-container">
                <button className="slider-arrow left-arrow" onClick={handlePrev} aria-label="Previous">
                  <FaChevronLeft />
                </button>
                <div className="slider-image-frame">
                  <img
                    src={selectedModel.photos[activePhotoIndex]}
                    alt={`${selectedModel.name} slide`}
                    className="slider-main-img"
                  />
                </div>
                <button className="slider-arrow right-arrow" onClick={handleNext} aria-label="Next">
                  <FaChevronRight />
                </button>
              </div>

              {/* Right Side: Model Details */}
              <div className="details-container">
                <div className="details-header">
                  <h2 className="details-name">{selectedModel.name}</h2>
                  <span className="details-city">{selectedModel.city}</span>
                </div>

                <div className="details-specs">
                  <div className="spec-row">
                    <span>Age</span>
                    <strong>{selectedModel.age} Years</strong>
                  </div>
                  <div className="spec-row">
                    <span>Height</span>
                    <strong>{selectedModel.height}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Hair</span>
                    <strong>{selectedModel.hair}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Eyes</span>
                    <strong>{selectedModel.eyes}</strong>
                  </div>
                </div>

                <div className="details-actions">
                  <button
                    className="shortlist-btn"
                    onClick={() => toggleShortlist(selectedModel.id)}
                  >
                    {shortlisted.includes(selectedModel.id) ? (
                      <>
                        <FaHeart className="heart-icon-filled" /> Shortlisted
                      </>
                    ) : (
                      <>
                        <FaRegHeart /> Shortlist Model
                      </>
                    )}
                  </button>
                  <button className="enquire-btn">Enquire About Artist</button>
                </div>
              </div>
            </div>

            {/* Bottom Next Line: Thumbnails Carousel */}
            <div className="modal-thumbnails-bar">
              <span className="thumbnails-title">
                Photos ({activePhotoIndex + 1} / {selectedModel.photos.length}):
              </span>
              <div className="thumbnails-track">
                {selectedModel.photos.map((photo, index) => (
                  <div
                    key={index}
                    className={`thumbnail-item ${index === activePhotoIndex ? 'active-thumb' : ''}`}
                    onClick={() => setActivePhotoIndex(index)}
                  >
                    <img src={photo} alt="thumbnail" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FemalechildModel;